var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.29289V0.5C5.5 0.22386 5.27614 0 5 0C4.72386 0 4.5 0.22386 4.5 0.5V5.29289L2.85355 3.64645C2.65829 3.45118 2.34171 3.45118 2.14645 3.64645C1.95118 3.84171 1.95118 4.15829 2.14645 4.35355L5 7.2071L7.8536 4.35355C8.0488 4.15829 8.0488 3.84171 7.8536 3.64645C7.6583 3.45119 7.3417 3.45119 7.1464 3.64645L5.5 5.29289Z",
    fill: "#005683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.5C1.27614 6.5 1.5 6.72386 1.5 7V7.8C1.5 8.1866 1.8134 8.5 2.2 8.5H7.8C8.1866 8.5 8.5 8.1866 8.5 7.8V7C8.5 6.72386 8.7239 6.5 9 6.5C9.2761 6.5 9.5 6.72386 9.5 7V7.8C9.5 8.7389 8.7389 9.5 7.8 9.5H2.2C1.26112 9.5 0.5 8.7389 0.5 7.8V7C0.5 6.72386 0.72386 6.5 1 6.5Z",
    fill: "#005683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.b65dc52d91177ac2aaa7829ddb37d203.svg";
export { ForwardRef as ReactComponent };